import { App_Url_New } from "@/shared/common/static";
import { axiosInstance } from "@/shared/lib/axiosInstance";

let cachedMasterData: unknown = null;
let inFlightRequest: Promise<unknown> | null = null;

function extractPayload(responseData: any) {
  if (!responseData || typeof responseData !== "object") return null;

  return responseData.data ?? responseData.result ?? responseData.results ?? responseData;
}

export async function fetchHealthMasterData(forceRefresh = false): Promise<unknown> {
  if (!forceRefresh && cachedMasterData) {
    return cachedMasterData;
  }

  if (!forceRefresh && inFlightRequest) {
    return inFlightRequest;
  }

  inFlightRequest = axiosInstance
    .get(App_Url_New.ApiEndPoint.healthQuoteMasterData)
    .then((response) => {
      const payload = extractPayload(response?.data);
      cachedMasterData = payload;
      return payload;
    })
    .catch((error) => {
      console.error("Failed to fetch health master data:", error);
      return null;
    })
    .finally(() => {
      inFlightRequest = null;
    });

  return inFlightRequest;
}

export function clearHealthMasterDataCache() {
  cachedMasterData = null;
  inFlightRequest = null;
}
